import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/account-settings')({
  beforeLoad: () => getTitleContextSlice('Account Settings'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
